// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__QRc1_"};